import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

export const CustomDatePicker = (props) => {
  return <DatePicker {...props}/>
}